import { FILE_SCOPE_POST } from '../../../../constants/file'
import { FilesContentGallery } from '../../../FilesContentGallery'
import { isSystemPostType } from '../../Newsboard.utils'
import { PostBodySkeleton } from '../../PostBodySkeleton'

import { NewsboardPostBodyMessage } from './NewsboardPostBodyMessage'

import * as styles from './NewsboardPostBody.module.css'

function NewsboardPostBody({ data, loading, ...restProps }) {
  return (
    <div className={styles.NewsboardPostBody}>
      {loading ? (
        <PostBodySkeleton />
      ) : (
        <>
          <NewsboardPostBodyMessage {...restProps} data={data} />
          {data?.files.length > 0 ? (
            <FilesContentGallery
              DownloadAll={isSystemPostType(data) ? null : undefined}
              files={data.files}
              scope={FILE_SCOPE_POST}
            />
          ) : null}
        </>
      )}
    </div>
  )
}

export default NewsboardPostBody
